import { useState } from 'react'
import { enhancedChatService, type BirthData } from '../services/enhancedChatService'

const TestChat = () => {
  const [message, setMessage] = useState('')
  const [response, setResponse] = useState('')
  const [loading, setLoading] = useState(false)
  const [logs, setLogs] = useState<string[]>([])

  const birthData: BirthData = {
    day: 15,
    month: 7,
    year: 1995,
    hour: 18,
    minute: 45,
    latitude: 34.0522,
    longitude: -118.2437,
    place_of_birth: 'Los Angeles'
  }

  const addLog = (log: string) => {
    setLogs(prev => [...prev, `${new Date().toLocaleTimeString()}: ${log}`])
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    if (!message.trim()) return

    setLoading(true)
    addLog(`Sending message: ${message}`)

    try {
      // Initialize the service
      enhancedChatService.initialize('test_user', birthData)
      addLog('Service initialized')

      // Send message
      const result = await enhancedChatService.sendMessage(message)
      addLog(`Response received: ${result.success ? 'SUCCESS' : 'ERROR'}`)
      
      if (result.success) {
        setResponse(result.message)
        addLog(`Message: ${result.message}`)
        addLog(`Confidence: ${result.confidence}`)
        addLog(`Sources: ${result.sources?.join(', ')}`)
      } else {
        setResponse('Error: ' + (result.error || 'Unknown error'))
        addLog(`Error: ${result.error}`)
      }
    } catch (error: any) {
      const errorMsg = error.message || 'Unknown error'
      setResponse('Error: ' + errorMsg)
      addLog(`Exception: ${errorMsg}`)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen bg-gray-900 text-white p-8">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold mb-8">Chat Test Page</h1>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Chat Interface */}
          <div className="bg-gray-800 rounded-lg p-6">
            <h2 className="text-xl font-semibold mb-4">Chat Test</h2>
            
            <form onSubmit={handleSubmit} className="mb-4">
              <input
                type="text"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="Enter your message..."
                className="w-full p-3 bg-gray-700 rounded border border-gray-600 text-white"
                disabled={loading}
              />
              <button
                type="submit"
                disabled={loading}
                className="mt-2 px-4 py-2 bg-blue-600 rounded hover:bg-blue-700 disabled:opacity-50"
              >
                {loading ? 'Sending...' : 'Send'}
              </button>
            </form>

            {response && (
              <div className="bg-gray-700 rounded p-4">
                <h3 className="font-semibold mb-2">Response:</h3>
                <p className="text-gray-300">{response}</p>
              </div>
            )}
          </div>

          {/* Logs */}
          <div className="bg-gray-800 rounded-lg p-6">
            <h2 className="text-xl font-semibold mb-4">Debug Logs</h2>
            <div className="bg-black rounded p-4 h-96 overflow-y-auto font-mono text-sm">
              {logs.map((log, index) => (
                <div key={index} className="text-green-400 mb-1">
                  {log}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TestChat 